export default __webpack_public_path__ + "static/inex_one_logo-705a7a7e6f3334f5a47408d213e9c14c.svg";